
import angular from "angular";
import moment from "moment-timezone";

import ngSanitize from "angular-sanitize";

import CurrentTimeZoneServiceModule from "../../services/CurrentTimeZoneService";

import Assert from "tbAssert";

const mLogSvc = new WeakMap();
const mCurrentTimeZoneSvc = new WeakMap();

const mParseFormat = new WeakMap();
const mEventFilterData = new WeakMap();

class EventRangeFilter {
    constructor($log, CurrentTimeZone, {eventFilter, parseFormat, rangeStart, rangeEnd}) {

        Assert.StrictAssert(eventFilter != null, "Assertion Failure: Missing Event Filter Model Dependency");
        Assert.StrictAssert($log != null, "Assertion Failure: Missing Log Service Dependency");
        Assert.StrictAssert(CurrentTimeZone != null, "Assertion Failure: Missing Current Time Zone Service Dependency");

        mLogSvc.set(this, $log);
        mCurrentTimeZoneSvc.set(this, CurrentTimeZone);
        mEventFilterData.set(this, eventFilter);

        if (angular.isString(parseFormat)) {
            mParseFormat.set(this, parseFormat);
        }
        else {
            throw new TypeError("Event Range Filter: Invalid or missing date parse format string.");
        }

        let processedRangeStart = this._processRangeParameter(rangeStart);
        let processedRangeEnd = this._processRangeParameter(rangeEnd);

        mEventFilterData.get(this).rangeStart = processedRangeStart;
        mEventFilterData.get(this).rangeEnd = processedRangeEnd;
    }

    static Create($log, CurrentTimeZone) {
        return ((eventRangeFilterParams) => new EventRangeFilter($log, CurrentTimeZone, eventRangeFilterParams));
    }

    _processRangeParameter(rangeParam) {
        if (rangeParam == null) {
            return null;
        }
        else if (moment.isMoment(rangeParam)) {
            if (rangeParam.isValid()) {
                return rangeParam;
            }
            else {
                return null;
            }
        }
        else if (moment.isDate(rangeParam)) {
            return moment(rangeParam).tz(mCurrentTimeZoneSvc.get(this).get()); //Verify time zone necessity.
        }
        else if (angular.isString(rangeParam)) {
            let parseFormat = mParseFormat.get(this);
            let rangeParamMoment = moment(rangeParam, parseFormat).tz(mCurrentTimeZoneSvc.get(this).get());
            if (rangeParamMoment.isValid()) {
                return rangeParamMoment;
            }
            else {
                return null;
            }
        }
        else {
            return null;
        }
    }

    get hasStart() {
        return mEventFilterData.get(this).hasRangeStart;
    }

    get startVal() {
        let formattedStart = (this.hasStart ? mEventFilterData.get(this).rangeStart.format(mParseFormat.get(this)) : null);
        return formattedStart;
    }

    set startVal(dateStr) {
        let processedStartParam = this._processRangeParameter(dateStr);
        mEventFilterData.get(this).rangeStart = processedStartParam;
    }

    get hasEnd() {
        return mEventFilterData.get(this).hasRangeEnd;
    }

    get endVal() {
        let formattedEnd = (this.hasEnd ? mEventFilterData.get(this).rangeEnd.format(mParseFormat.get(this)) : null);
        return formattedEnd;
    }

    set endVal(dateStr) {
        let processedEndParam = this._processRangeParameter(dateStr);
        mEventFilterData.get(this).rangeEnd = processedEndParam;
    }

    toString() {
        return `EventRangeFilter/${(this.hasStart ? mEventFilterData.get(this).rangeStart.toISOString() : "(null)")}/${(this.hasEnd ? mEventFilterData.get(this).rangeEnd.toISOString() : "(null)")}/`;
    }

    clear() {
        let eventFilterData = mEventFilterData.get(this);
        eventFilterData.rangeStart = null;
        eventFilterData.rangeEnd = null;
    }


}

EventRangeFilter.Create.$inject = [ "$log", "CurrentTimeZone" ];

export default angular
    .module("trackerbase-app.views.event-filter-panel.event-range-filter",[
        ngSanitize,
        CurrentTimeZoneServiceModule
    ])
    .factory("EventRangeFilter", EventRangeFilter.Create)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/views/event-filter-panel/EventRangeFilter.js
// module id = pKD4
// module chunks = 1